import { useState } from 'react';
import api from '../services/api';
import SEO from '../components/SEO';

const RegisterPage = ({ switchToLogin }) => {
  const [form, setForm] = useState({ name: '', email: '', password: '', role: 'student', college: '' });
  const [retypePassword, setRetypePassword] = useState('');
  const [error, setError] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setStatus('');

    if (form.password !== retypePassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      const res = await api.post('/auth/register', form);
      setStatus(res.data.message);
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <SEO title="Register" description="Create a Study Centro account to start preparing for your exams." />
      <div className="auth-card">
        <div className="auth-header">
          <div className="top-menu-logo" style={{ margin: '0 auto 20px', width: '48px', height: '48px' }}>
            <i className="fas fa-user-plus" />
          </div>
          <h2>Register</h2>
        </div>
        
        {status ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: '3rem', color: 'var(--success)', marginBottom: '16px' }}>
              <i className="fas fa-envelope-open-text" />
            </div>
            <h3 style={{ marginBottom: '12px' }}>Verify your email</h3>
            <p style={{ color: 'var(--text-muted)', lineHeight: '1.6' }}>{status}</p>
            <button 
              type="button" 
              className="primary" 
              onClick={switchToLogin} 
              style={{ marginTop: '24px', width: '100%' }}
            >
              Back to Login
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
            <div style={{ display: 'grid', gap: '8px', marginBottom: '16px' }}>
              <label>Full Name</label>
              <input name="name" value={form.name} onChange={handleChange} required placeholder="John Doe" />
            </div>

            <div style={{ display: 'grid', gap: '8px', marginBottom: '16px' }}>
              <label>Email Address</label>
              <input name="email" type="email" value={form.email} onChange={handleChange} required placeholder="john@college.edu" />
            </div>

            <div className="auth-grid">
              <div style={{ display: 'grid', gap: '8px', position: 'relative' }}>
                <label>Password</label>
                <div style={{ position: 'relative' }}>
                  <input 
                    name="password" 
                    type="password" 
                    value={form.password} 
                    onChange={handleChange} 
                    required 
                    placeholder="••••••••"
                    style={{ width: '100%' }}
                  />
                </div>
              </div>
              <div style={{ display: 'grid', gap: '8px' }}>
                <label>Retype Password</label>
                <input 
                  type="password" 
                  value={retypePassword} 
                  onChange={e => setRetypePassword(e.target.value)} 
                  required 
                  placeholder="••••••••" 
                />
              </div>
            </div>

            <div className="auth-grid">
              <div style={{ display: 'grid', gap: '8px' }}>
                <label>Role</label>
                <select name="role" value={form.role} onChange={handleChange}>
                  <option value="student">Student</option>
                  <option value="teacher">Teacher</option>
                </select>
              </div>
              <div style={{ display: 'grid', gap: '8px' }}>
                <label>College (optional)</label>
                <input name="college" value={form.college} onChange={handleChange} placeholder="College Name" />
              </div>
            </div>
            
            {error && <div className="error-message" style={{ marginTop: '8px' }}>{error}</div>}
            
            <button type="submit" disabled={loading} style={{ marginTop: '24px', width: '100%', padding: '14px', background: 'var(--primary)', color: 'white', border: 'none', borderRadius: 'var(--radius-md)', fontWeight: 600 }}>
              {loading ? 'Creating Account...' : 'Create Account'}
            </button>
          </form>
        )}
        
        <div style={{ marginTop: '32px', paddingTop: '24px', borderTop: '1px solid var(--border-light)', textAlign: 'center' }}>
          <p style={{ fontSize: '0.95rem', color: 'var(--text-muted)', margin: 0 }}>
            Already have an account?
          </p>
          <button 
            type="button" 
            onClick={switchToLogin}
            style={{ background: 'none', border: 'none', color: 'var(--primary)', fontWeight: 700, fontSize: '1rem', cursor: 'pointer', marginTop: '8px', padding: '4px 12px', borderRadius: '8px', transition: 'all 0.2s' }}
            onMouseOver={e => e.target.style.background = 'rgba(79, 70, 229, 0.05)'}
            onMouseOut={e => e.target.style.background = 'none'}
          >
            Sign in here
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
